export const STORAGE_KEY = 'enabledLogAnalytics';

export const PROD_HOST_NAME = 'leroymerlin.ru';

export const GTM_CHECK_ATTEMPT_COUNT = 10;
